import type { TabProps } from '@meterup/atto';

import { paths } from '../../../../constants';
import { useCurrentCompany } from '../../../../providers/CurrentCompanyProvider';
import { makeLink } from '../../../../utils/main_and_drawer_navigation';
import { useGetAccessLevelForUser } from '../../../HasAccess/useAccessLevelForUser';
import { ReactRouterLink } from '../../../ReactRouterLink';

export enum IntegrationsTab {
  Receivers = 'receivers',
  Services = 'services',
  Webhooks = 'webhooks',
}

export function IntegrationsTabs({ activeTab }: { activeTab: IntegrationsTab }) {
  const companyName = useCurrentCompany();

  const getAccessLevel = useGetAccessLevelForUser();
  const webhooksAccessLevel = getAccessLevel({
    featureFlags: ['webhook-integrations'],
  });
  const servicesAccessLevel = getAccessLevel({
    featureFlags: ['service-integrations'],
  });

  return [
    {
      accessLevel: servicesAccessLevel,
      as: ReactRouterLink,
      to: makeLink(paths.pages.SettingsOrgIntegrationsPage, {
        companyName,
        tab: IntegrationsTab.Services,
      }),
      selected: activeTab === IntegrationsTab.Services,
      icon: 'service',
      label: 'Services',
    },
    {
      accessLevel: webhooksAccessLevel,
      as: ReactRouterLink,
      to: makeLink(paths.pages.SettingsOrgIntegrationsPage, {
        companyName,
        tab: IntegrationsTab.Webhooks,
      }),
      selected: activeTab === IntegrationsTab.Webhooks,
      icon: 'webhook',
      label: 'Webhooks',
    },
    {
      as: ReactRouterLink,
      to: makeLink(paths.pages.SettingsOrgIntegrationsPage, {
        companyName,
        tab: IntegrationsTab.Receivers,
      }),
      selected: activeTab === IntegrationsTab.Receivers,
      icon: 'tag',
      label: 'Receivers',
    },
  ] as TabProps[];
}
